import styled from "styled-components/macro";

import { colors } from "UI/colors";

/* Shared focus-ring wrappers + field style constants for the grouped address
   card. Used by the inline ExtendedFields surface and the FamilyRegistration
   public page; each surface keeps its own zip wrapper (their sizing genuinely
   differs) and any extra per-surface overrides. */

/* Z-index scale inside the address card (scoped by AddressAutocompleteRoot's
   `isolation: isolate`):
     0 — unfocused inputs (default)
     1 — focused input wrapper (raises its outset focus ring above siblings)
     2 — country flag corner (CountryFlagCorner), so a focused Street field
         doesn't stack over and cover the flag nested in its corner */
export const FocusWrapper = styled.div`
  &:focus-within {
    z-index: 1;
    box-shadow: ${(props) => `0 0 0 2px ${props.focusColor}`};
  }
`;

export const StreetWrapper = styled(FocusWrapper)`
  /* Top corners only — StreetWrapper is the address grid's top row, so only its top edges show. */
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  flex: 1;
`;

export const CityWrapper = styled(FocusWrapper)`
  /* Bottom-left only — CityWrapper is the grid's bottom-left cell; the bottom-right edge is an adjacent field. */
  border-bottom-left-radius: 5px;
  flex: 1;
`;

export const wrapperStyles = {
  border: `1px solid ${colors.fnBorderGray2}`,
};

// 6px wrapper padding, with or without the country flag. The 36px corner the
// flag sits in is reserved on the INPUT (each consumer's StyledLine1 input
// rule), not here: this `style` lands on StreetField's wrapper, and wrapper
// padding parks the flag OUTSIDE the input's box — visibly outside its focus
// ring, and uncentered in the field rather than nested in the corner.
export const streetStyle = {
  borderTopLeftRadius: "5px",
  borderTopRightRadius: "5px",
  padding: "6px",
};

export const stateFieldStyle = { width: "80px" };
